
export const loaderFacts = [
  {
    text: "Feeling stuck?",
    cta: "Let the Find Your Verse Tool deliver Scripture that speaks to your situation.",
    route: "/find-your-verse"
  },
  {
    text: "Struggling with how to pray?",
    cta: "Selah's Prayer Generator helps you begin with truth, not guesswork.",
    route: "/prayer-generator"
  },
  {
    text: "Unsure how to respond to today's cultural chaos?",
    cta: "The Moral & Ethical Dilemmas Tool gives you clarity grounded in the Word.",
    route: "/apologetics"
  },
  {
    text: "Got deep questions about suffering, the Trinity, or free will?",
    cta: "The Theology Answers Tool walks with you, step by step.",
    route: "/deep-dive"
  },
  {
    text: "Need to train for tough conversations with nonbelievers?",
    cta: "Start a session in the Evangelism Training Tool now.",
    route: "/apologetics"
  },
  {
    text: "You don't have to walk through doubt alone.",
    cta: "Try the Addressing Atheism Tool and build confidence through truth.",
    route: "/apologetics"
  },
  {
    text: "What does God's Word really say about love, justice, or fear?",
    cta: "The Scripture Navigator helps you explore themes in context.",
    route: "/scripture-navigator"
  },
  {
    text: "Need a study plan you'll actually finish?",
    cta: "Use the Bible Reading Plan Creator to generate one in seconds.",
    route: "/reading-plan"
  },
  {
    text: "Not all religions lead to the same place.",
    cta: "The Interfaith Dialogue Tool shows why Jesus is still the only way.",
    route: "/apologetics"
  },
  {
    text: "Want to know where \"agape\" really comes from?",
    cta: "Open the Biblical Etymology Tool to dig into original meaning.",
    route: "/etymology"
  },
  {
    text: "Just type how you're feeling.",
    cta: "The Prayer Generator will turn it into a Scripture-based prayer.",
    route: "/prayer-generator"
  },
  {
    text: "What does the Bible really say about abortion? Identity? Justice?",
    cta: "The Ethical Dilemmas Tool gives you solid, respectful answers.",
    route: "/apologetics"
  },
  {
    text: "You're not wrong for asking hard questions.",
    cta: "The Theology Answers Tool helps you wrestle with wisdom.",
    route: "/deep-dive"
  },
  {
    text: "Want to build a deeper relationship with the Word itself?",
    cta: "Try the Scripture Navigator now.",
    route: "/scripture-navigator"
  },
  {
    text: "Looking for more than a devotional app?",
    cta: "The Reading Plan Tool gives you structure, context, and daily purpose.",
    route: "/reading-plan"
  },
  {
    text: "Curious how Christianity compares with Islam, Mormonism, or Judaism?",
    cta: "Tap into the Interfaith Dialogue Tool.",
    route: "/apologetics"
  },
  {
    text: "The Bible is layered.",
    cta: "The Deep Dive Commentary helps you unpack it, verse by verse.",
    route: "/deep-dive"
  },
  {
    text: "Want to understand the original biblical language?",
    cta: "The Etymology Tool is your starting point.",
    route: "/etymology"
  },
  {
    text: "Start your day with prayer—even when you're out of words.",
    cta: "The Prayer Generator meets you in that moment.",
    route: "/prayer-generator"
  },
  {
    text: "Find the right verse for the wrong moment.",
    cta: "Use the Find Your Verse Tool.",
    route: "/find-your-verse"
  },
  {
    text: "Want to grow in faith, not just learn facts?",
    cta: "The Bible Reading Plan Creator can walk with you.",
    route: "/reading-plan"
  },
  {
    text: "Ever been challenged by someone who doesn't believe in God?",
    cta: "Respond with compassion using the Addressing Atheism Tool.",
    route: "/apologetics"
  },
  {
    text: "What's the theological significance of your favorite verse?",
    cta: "The Deep Dive Commentary brings it to life.",
    route: "/deep-dive"
  },
  {
    text: "Want to explore biblical themes across multiple books?",
    cta: "Use the Scripture Navigator to study deeper.",
    route: "/scripture-navigator"
  },
  {
    text: "Your questions are not too much for God.",
    cta: "Selah's Theology Answers Tool meets you in them.",
    route: "/deep-dive"
  },
  {
    text: "Ready to stop scrolling and start growing?",
    cta: "Build a plan in the Reading Plan Creator.",
    route: "/reading-plan"
  },
  {
    text: "Struggling to share your faith with people who disagree?",
    cta: "The Evangelism Trainer helps you practice without fear.",
    route: "/apologetics"
  },
  {
    text: "Tired of shallow answers?",
    cta: "The Deep Dive Commentary delivers rich insight and truth.",
    route: "/deep-dive"
  },
  {
    text: "Love, justice, freedom, identity—God's Word has something to say.",
    cta: "Explore it all in the Scripture Navigator.",
    route: "/scripture-navigator"
  },
  {
    text: "You don't need to fake spiritual strength.",
    cta: "Just open the Prayer Generator and start.",
    route: "/prayer-generator"
  },
  {
    text: "Build a plan. Build a rhythm. Build a foundation.",
    cta: "Start with the Reading Plan Tool.",
    route: "/reading-plan"
  },
  {
    text: "Stop guessing. Start growing.",
    cta: "Selah meets you with truth for every moment.",
    route: "/bible-tools"
  }
];
